import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import NewCustomModal from "../../../../../../../../custom_utilities/Modal/CustomModal";
import "./VarientCard.scss";

const VarientCard = ({
  show,
  onHide,
  packageId,
  startLoading,
  finishLoading,
  history,
}) => {
  const [packageVariants, setPackageVariants] = useState();
  const [packageTitle, setPackageTitle] = useState();

  const fetchPackageData = useCallback(
    async (packageId) => {
      startLoading();
      try {
        const response = await axios.get(
          `https://learning.motion.ac.in/motioneducation/api/user/package_detail_web?package_id=${packageId}`
        );
        const data = response.data.data;
        setPackageVariants(data.package_quick_variants);
        setPackageTitle(data);
      } catch (error) {
        console.error(error);
      } finally {
        finishLoading();
      }
    },
    [startLoading, finishLoading]
  );

  useEffect(() => {
    if (packageId) {
      fetchPackageData(packageId);
    }
  }, [packageId, fetchPackageData]);

  const handleClickBuynow = (variant) => {
    history.push(`/package/${variant?.package_id}`);
  };

  return (
    <NewCustomModal
      isOpen={show}
      closeModal={onHide}
      title={packageTitle?.PackageInstallmentDetails?.package_name}
      size="medium"
      hideXIcon={false}
      width="650px"
      height="630px"
    >
      <div className="variant-list">
        {packageVariants?.quick_variants_selection_options?.map((variant) => (
          <div className="variant-card" key={variant.package_id}>
            <div className="variant-content">
              <div className="variant-info">
                <h6 className="variant-title">{variant.package_name}</h6>
              </div>

              <div className="variant-price">{variant.price}</div>
            </div>
            <div className="validity-text" style={{ textAlign: "left" }}>
              {variant.duration}
            </div>
            <div className="variant-actions">
              {!variant.is_subscribe ? (
                <button
                  className="buy-btn"
                  onClick={() => handleClickBuynow(variant)}
                >
                  Buy Now
                </button>
              ) : (
                <button
                  className="view-details-btn"
                  onClick={() => handleClickBuynow(variant)}
                >
                  View details
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </NewCustomModal>
  );
};

export default VarientCard;
